import { HTTP, getAuthorizationHeader } from "../../_helper/http-constants"

const verifySchoolCode = async (schoolCode) => {
    // check if the school code is valid
    let school = null
    try {
        const res = await HTTP.get("/schools/" + schoolCode)
        school = res.data.result
    } catch (err) {
        // school code is not valid.
        console.log("error in validating school", err)
    }
    return school
}

const ReadingMaterialTypeSlugs = {
    BOOK_PRE_READING_MATERIAL: "book_pre_reading_material",
    TOPIC_PRE_READING_MATERIAL: "topic_pre_reading_material",
    TOPIC_READING_MATERIAL: "topic_reading_material",
}

async function attachScript(link) {
    return new Promise((resolve, reject) => {
        const script = document.createElement("script")
        script.setAttribute("src", link)
        document.body.appendChild(script)
        script.onload = () => {
            resolve(link)
        }
        script.onerror = () => {
            reject(link)
        }
    })
}

function attachStyle(link) {
    const style = document.createElement("link")
    style.setAttribute("rel", "stylesheet")
    // style.setAttribute("type", "text/css")
    style.setAttribute("href", link)
    document.head.appendChild(style)
}

async function fetchUserFromId(studentId) {
    const res = await HTTP.get("/users/" + studentId, {
        headers: getAuthorizationHeader(),
    })
    console.log("student fetched from id: ", res.data)
    if (res.data.user) {
        return res.data.user
    }
}

async function getSubjectProgressUtil(userId, user) {
    try {
        const res = await HTTP.get("/course-progress/student/subject-progress?user_id=" + userId, {
            headers: getAuthorizationHeader(),
        })
        const subjectIdProgress = res.data.progress
        const subjectProgress = user.interested_subjects.map((item) => ({
            name: item.name,
            value: subjectIdProgress[item._id],
        }))
        return subjectProgress
    } catch (err) {
        console.log("error in getting student summary")
    }
}

export {
    getSubjectProgressUtil,
    verifySchoolCode,
    ReadingMaterialTypeSlugs,
    attachScript,
    attachStyle,
    fetchUserFromId,
}
